module.exports = __webpack_public_path__ + "img/Crustacean.6ed3af50.svg";